import { Component, ChangeDetectionStrategy } from '@angular/core';
import { CarBusinessLine } from 'src/app/public/car/constants/car-basic-data';

@Component({
    selector: 'app-buy-car-card-list',
    templateUrl: './buy-car-card-list.component.html',
    styleUrls: ['./buy-car-card-list.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class BuyCarCardListComponent {

  businessLine: CarBusinessLine = CarBusinessLine.BUY; 

}
